import {isNullOrUndefined} from "../../../../services/Validator";
import SystemExerciserWarningDivider from "../../../dividers/SystemExerciserWarningDivider";

export default function ExerciserQuestionWarningText({warning}) {
    // Used through the app to display Exerciser question
    // warning text

    // BUILD
    if (isNullOrUndefined(warning))
        return null
    return (
        <div className={"w-full flex flex-col text-center whitespace-pre-line"}>
            <SystemExerciserWarningDivider />
            <span className={"text-[16px] font-normal text-greyLight7"}>
              {warning}
            </span>
        </div>
    );
}